module.exports = __webpack_public_path__ + "media/site_templates/www.furnituredisposal.com.au/images/about_us-c5856e49c21564cd9d4507e00c17742d.jpg";